import { Grid, Typography, makeStyles, Theme } from '@material-ui/core';
import { observer } from 'mobx-react';
import { BORROWER_IDENTITY_VERIFICATION } from '@roc/feature-documents';
import { useStore } from '@roc/client-portal-shared/hooks';
import { IdentityLinkInformation } from '@roc/client-portal-shared/modules/idVerification';
import { DocReviewUploader } from '../../docReviewUploader';

const useStyles = makeStyles((theme: Theme) => ({
  sectionLabel: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
}));

export const IdentityUploader = observer(() => {
  const classes = useStyles();
  const { docReviewStoreV2, loanStore } = useStore();
  const { document } = docReviewStoreV2;
  const borrowerId = document?.borrowerId;
  const loanDetails =
    loanStore.loanDetails?.loanId === document?.loanId
      ? loanStore.loanDetails
      : null;

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.sectionLabel}>
          Submitted Identification Document
        </Typography>
        {borrowerId && loanDetails && (
          <IdentityLinkInformation borrowerId={borrowerId} loan={loanDetails} />
        )}
      </Grid>
      {!!document.dropboxPath && (
        <Grid item xs={12}>
          <DocReviewUploader />
        </Grid>
      )}
    </>
  );
});
